import React, { Component, Fragment } from "react";
import CenterElement from "../../activity/activityComponent/CenterElement";
import DropItemUI from "../../ddTxtImg/ui/DropItemUI";
import ReactDOM from "react-dom";
import $ from "jquery";
import "popper.js/dist/popper";
import "bootstrap/dist/js/bootstrap";
import DragItem from "../../ddTxtImg/model/DragItem";

class WordOnImgDropItemUI extends DropItemUI {
  constructor() {
    super();
    this.popover = React.createRef();
  }

  state = {
    showImg: false,
  };
  componentDidUpdate = () => {
    $(ReactDOM.findDOMNode(this.popover.current)).popover({
      trigger: "focus",
    });

    if (this.itemToDrop != null) window.x(this.itemToDrop);
  };

  componentDidMount = () => {
    let { quizViewer, dropItem, activity } = this.props;
    let { quizViwerModel } = quizViewer.state;
    $(ReactDOM.findDOMNode(this.itemToDrop)).droppable({
      drop: () => {
        // this.props.activity.currentDragItem=null

        dropItem.solvedDragItem = new DragItem();
        dropItem.solvedDragItem.initFromJson(
          activity.currentDragItem.getAsJson()
        );
        activity.currentDragItemHtml.style.display = "none";

        if (dropItem.solvedDragItemHtml) {
          dropItem.solvedDragItemHtml.style.display = "inline-block";
        }

        dropItem.solvedDragItemHtml = activity.currentDragItemHtml;

        if (activity.currentDragItem.dragItemType == dropItem.IMG_TYPE) {
          dropItem.dropType = dropItem.IMG_TYPE;
          dropItem.dropImg = activity.currentDragItem.dragImgUrl;
          this.setState({ showImg: true });
        }

        dropItem.dropTxt =
          dropItem.solvedDragItem.dragViewTxt != "" &&
          dropItem.solvedDragItem.dragViewTxt != undefined
            ? dropItem.solvedDragItem.dragViewTxt
            : dropItem.solvedDragItem.dragTxt;

        quizViewer.setState({ quizViwerModel });

        // if (this.itemToDrop == null) {
        //     this.itemToChangeBorder.style.borderColor = "green"
        //     this.itemToChangeBorder.style.borderWidth = "2px"
        // }
        // else {
        //     this.itemToDrop.style.borderColor = "green"
        //     this.itemToDrop.style.borderWidth = "2px"
        // }

        // setTimeout(() => {
        //     if (this.itemToDrop == null) {
        //         this.itemToChangeBorder.style.borderColor = "black"
        //         this.itemToChangeBorder.style.borderWidth = "1px"
        //     }
        //     else {
        //         this.itemToDrop.style.borderColor = "green"
        //         this.itemToDrop.style.borderWidth = "2px"
        //     }
        // }, 500)
      },
    });
  };

  extraAction = () => {};
  getFullDropItem = () => {
    let { dropItem, activity, quizViewer, autoPosition } = this.props;

    let { selectedStyle } = activity.dropItemContainer;
    let { quizViwerModel } = quizViewer.state;

    return <Fragment>{this.getDropItem()}</Fragment>;
  };

  getDropItem = () => {
    let { dropItem, quizViewer, autoPosition, activity } = this.props;
    let { quizViwerModel } = quizViewer.state;

    let txt = "";

    if (typeof dropItem.dropTxt == "string")
      txt = dropItem.dropTxt.replace(/<\/?[^>]+>/gi, " ");
    else txt = JSON.stringify(dropItem.dropTxt).replace(/<\/?[^>]+>/gi, " ");
    let defaultTxt = "اسحب هنا!";
    let correctAnswers = dropItem.getAvailableAns();
    let color = dropItem.isAnsewredTrue() ? "#58C4A4" : "#FF627F";

    if (dropItem.dropType == dropItem.TXT_TYPE)
      return (
        <Fragment>
          {!quizViwerModel.reviewMode ? (
            <div
              style={{
                minHeight: "65px",
                minWidth: "100px",
                padding: "5px",
                position: autoPosition ? "relative" : "absolute",
                width: autoPosition ? "auto" : dropItem.w + "px",
                height: autoPosition ? "auto" : dropItem.h + "px",
                top: autoPosition ? "auto" : dropItem.y + "px",
                border: "dotted 1px grey",
                marginLeft: autoPosition ? "10px" : "0px",
                display: autoPosition ? "inline-block" : "",
                transition: "borderWidth  2s",
              }}
              ref={(el) => (this.itemToChangeBorder = el)}
              className="item-shape"
              // onContextMenu={this.handleShowContextMenu}
              // ref={(el) => this.itemToDrag = el}
            >
              <table
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  top: "0",
                  left: "0",
                  right: "0",
                  margin: "0 auto",
                }}
                ref={(el) => (this.itemToDrop = el)}
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        fontSize: txt ? "11px" : "14px",
                        fontWeight: txt ? "bold" : "300",
                      }}
                    >
                      {txt == "" ? defaultTxt : txt}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          ) : (
            <a
              ref={this.popover}
              tabIndex="0"
              className="btn btn-lg popover-dismiss item-shape "
              style={{
                backgroundColor: color,
                color: "white",
                minHeight: "65px",
                minWidth: "100px",
                padding: "5px",
                margin: "7px",
                position: "relative",
              }}
              role="button"
              data-toggle="popover"
              data-trigger="focus"
              title="الاجابات الصحيحة"
              data-content={correctAnswers}
            >
              <table
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  top: "0",
                  left: "0",
                  right: "0",
                  margin: "0 auto",
                }}
              >
                <tbody>
                  <tr>
                    <td>{txt == "" ? defaultTxt : txt}</td>
                  </tr>
                </tbody>
              </table>
            </a>
          )}
        </Fragment>
      );
    else
      return (
        <Fragment>
          {!quizViwerModel.reviewMode ? (
            <div
              className=" d-flex  justify-content-center  align-self-center"
              ref={(el) => (this.itemToDrop = el)}
              style={{ minWidth: "100px", border: "0.5px dotted gray" }}
            >
              <div className="card-body" style={{ minHeight: "100px" }}>
                {this.state.showImg ? (
                  <img src={activity.imgUrl + dropItem.dropImg} />
                ) : (
                  ""
                )}
              </div>
            </div>
          ) : (
            <div
              className=" d-flex  justify-content-center  align-self-center"
              style={{ minWidth: "200px", border: "4px dotted " + color }}
            >
              <div className="card-body" style={{ height: "80px" }}>
                {this.state.showImg ? (
                  <img src={activity.imgUrl + dropItem.dropImg} />
                ) : (
                  ""
                )}
              </div>
            </div>
          )}
        </Fragment>
      );
  };
}
export default WordOnImgDropItemUI;
